import { INewbuildingPromo } from '@cian/frontend-newbuilding-promo-carousel-component';

import { INewbuildingForPromoSliderSchema } from '../repositories/newbuilding-search/entities/get_newbuildings_for_builders_promo_slider/NewbuildingForPromoSliderSchema';
import { IGetNewbuildingsForBuildersPromoSliderResponse } from '../repositories/newbuilding-search/v1/get-newbuildings-for-builders-promo-slider';
import { INewbuildingsForPromoSliderResponse } from '../types/newbuildingsForPromoSlider';

export const prepareNewbuildingPromo = (newbuilding: INewbuildingForPromoSliderSchema): INewbuildingPromo => ({
  address: newbuilding.address,
  id: newbuilding.id,
  imageUrl: newbuilding.imageUrl,
  isLoaded: true,
  minPrice: newbuilding.minPrice,
  name: newbuilding.name,
  statusDisplay: newbuilding.statusDisplay,
  undergroundInfo: newbuilding.undergroundInfo,
  url: newbuilding.url,
});

export const transformNewbuildingsForPromoSlider = (
  response: IGetNewbuildingsForBuildersPromoSliderResponse,
): INewbuildingsForPromoSliderResponse => {
  return {
    newbuildings: response.newbuildings.map(prepareNewbuildingPromo),
  };
};
